import { makeDataObjGenerator } from 'mocks/helpers'
import { RatingSourceEnum } from 'types/api/enums'
import { WorldTennisNumberTypeEnum } from 'types/api/enums'

const defaultData = {
  type: WorldTennisNumberTypeEnum.SINGLE,
  tennisNumber: 24.81,
  confidence: 0.6,
  gameZoneUpper: 21.78,
  gameZoneLower: 25.83,
  isRanked: false,
  source: RatingSourceEnum.PSQ,
  __typename: 'WorldTennisNumber',
}

export const createWorldTennisNumber = makeDataObjGenerator(defaultData)

export const worldTennisNumber = (data?: (typeof defaultData)[]) => ({
  worldTennisNumber: data || [
    createWorldTennisNumber(),
    createWorldTennisNumber({ type: WorldTennisNumberTypeEnum.DOUBLE }),
  ],
})
